import React from "react";

export default function NumberDisplay({
  fontawesomeIcon = null,
  number = null,
  title = null,
  variant = "default",
}) {
  if (variant === "plain")
    return (
      <div className="min-w-[100px] flex-1 rounded-xl bg-slate-50 px-4 py-4">
        <div className="mb-2 flex items-center gap-2 text-xs text-slate-500">
          <span aria-hidden="true">{fontawesomeIcon}</span>
          {title}
        </div>
        <p className="text-2xl font-semibold tabular-nums text-slate-900">
          {number}
        </p>
      </div>
    );
  return (
    <div className="h-[105px] w-[197px] border border-altgray-200 rounded-md mt-2.5 flex flex-col m-2 md:w-[197px] md:m-2 md:mb-4">
      <div className="bg-altgray-50 font-semibold pt-2 pb-1.5 text-[90%] border-b border-altgray-200 rounded-t-md flex items-center justify-center w-full">
        <div className="mr-2.5 text-orange-400">{fontawesomeIcon}</div> {title}
      </div>
      <div className="flex flex-row flex-1 justify-center items-center">
        <div className="flex items-center justify-center text-[150%] font-bold md:text-[200%]">
          {number}
        </div>
      </div>
    </div>
  );
}
